import React from 'react';
import { SnackbarProvider } from 'notistack';
import Routers from './Router';

function App() {
  return (
    <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Routers />
    </SnackbarProvider>
  );
}

export default App;
